import { ClearfixBasic } from "../../../../src/examples/utilities/Clearfix";
import * as React from 'react';
export default {
  ClearfixBasic,
  React
};